import React from 'react';

interface Props {
  guid: string
}

export const FieldError: React.FunctionComponent<Props> = ({ guid, children }) => (
  <div
    className="message error usa-alert usa-alert-error"
    key={guid}
    role="alert"
    aria-live="polite"
  >
    <div className="usa-alert-body">{children}</div>
  </div>
);
